import {startOfToday} from 'date-fns'
import React, {ChangeEvent, useEffect, useState} from 'react'
import {Lang} from 'yougile-lang'
import {BooleanHookState, useBoolean} from '@containers/hooks'
import {parseDatePart, stringifyDatePart} from '../util'
import {TwInput, TwInputContainer} from './text-input-base'

export interface DateTextInputProps {
  initialValue?: Date
  onChange: (date: Date) => void
  onValidate?: (isValid: boolean) => void
  disablePastDates?: boolean
  valid?: BooleanHookState
}

export const DateTextInput = (props: DateTextInputProps) => {
  const initialInputValue = stringifyDatePart(props.initialValue)
  const [inputValue, setInputValue] = useState(initialInputValue)
  const valid = props.valid ?? useBoolean(true)

  useEffect(() => {
    if (initialInputValue !== normalizeDatePart(inputValue)) {
      setInputValue(initialInputValue)
      valid.setValue(true)
    }
  }, [initialInputValue])

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {value} = event.target
    setInputValue(value)
    processInput(value)
  }

  const onBlur = () => {
    const value = normalizeDatePart(inputValue)
    setInputValue(value)
    processInput(value)
  }

  const processInput = (value: string) => {
    const datePart = parseDatePart(value)
    const isValid =
      Boolean(datePart) &&
      (!props.disablePastDates || datePart >= startOfToday())

    if (isValid) {
      props.onChange(datePart)
    }

    props.onValidate?.(isValid)
    valid.setValue(isValid)
  }

  useEffect(() => () => valid.turnOn(), [])

  return (
    <TwInputContainer className="w-96 px-8" $hasError={!valid.value}>
      <TwInput
        value={inputValue}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={Lang.msg.datePlaceholder}
      />
    </TwInputContainer>
  )
}

const normalizeDatePart = (value: string) => {
  const parsed = parseDatePart(value)
  return parsed ? stringifyDatePart(parsed) : value
}
